export const ds_ImagesBlock_Entry = `
    fragment ds_ImagesBlock_Entry on ds_ImagesBlock_Entry {
        id
        canonicalUid

        images_ColorPalette
        images_ColorTheme
        images_TopSpacing
        images_ContainerWidth
        images_FullWidthBackground

        images_TwoRows
        images_ImagesPerRow
        images_OffsetSecondImage
        images_TextLocation
        images_Carousel
        images_ImageItems {
            ... on ds_ImagesItem_Entry {
                imagesItem_ImageText
                imagesItem_Image {
                    url @transform(width: 1280, height: 720)
                    alt
                    focalPoint
                }
            }
        }
    }
`
